import { Alert, FieldLabel, TextInput } from '../../components/Primitives.jsx';

// Shared Output Name field + conditional-required warning, used by every
// step in the Source-anchored family (Unpivot, Group By, Arithmetic, and
// beyond — see SOURCE_ANCHOR_RESOLVERS in server/app/engine/executor.py for
// the backend counterpart). `required` is true exactly when
// execute_pipeline will revert this step's next_rows to the unchanged self
// payload after it runs, i.e. when Output Name is the only way to reach
// this step's result. `hint`/`warningMessage` are supplied by the caller
// (not derived here) since each step's own wording differs slightly by what
// "Source-anchored" means for it — this component only owns the shared
// skeleton (label/required marker, the field itself, and which Alert shows).
export function OutputNameField({ value, onChange, required, hint, warningMessage, placeholder, issue }) {
  return (
    <div style={{ marginTop: 10 }}>
      <FieldLabel hint={hint}>
        Output Name {required ? '(Required)' : '(Optional)'}
      </FieldLabel>
      <TextInput value={value || ''} onChange={onChange} placeholder={placeholder} />
      {required && (
        <Alert kind="warn" style={{ marginTop: 6 }}>{warningMessage}</Alert>
      )}
      {!required && issue && (
        <Alert kind={issue.level} style={{ marginTop: 6 }}>{issue.message}</Alert>
      )}
    </div>
  );
}
